import * as React from 'react';

import { mainSettingPanelPortraitComponent, MainSettingPanelPortraitComponentConfigurationContext } from './mainSettingPanelPortraitComponentConfiguration';

const withMainSettingPanelPortraitComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <MainSettingPanelPortraitComponentConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...mainSettingPanelPortraitComponent} />
                );
            }}
        </MainSettingPanelPortraitComponentConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withMainSettingPanelPortraitComponentConfiguration;